import { snapshot } from "valtio";
import store from "@/store";
import getAllProducts from "@/services/ProductService/getAllProducts";
import { CreateProduct } from "@/types/product";

const getNextProductData = async (
    productId: string,
    productForm: any
): Promise<CreateProduct | null> => {



    const { _validation, ...productData } = productForm;
    let { products } = snapshot(store);




    // Ensure products are loaded and handle null explicitly
    if (!products || products.length === 0) {
        const fetchedProducts = await getAllProducts();
        if (!fetchedProducts || fetchedProducts.length === 0) return null;
        products = fetchedProducts;
    }




    // Find the selected product
    const selectedProduct = products.find((p: any) => p.product_id === productId);
    if (!selectedProduct) return null;




    // Find all SKUs that match the selected product's SKU
    const matchedSkus = products
    .map(product => product.sku)
    .filter(existingSku => existingSku.startsWith(selectedProduct.sku));




    // Extract suffixes from the matched SKUs
    const suffixes = matchedSkus.map(existingSku => {
        const match = existingSku.match(new RegExp(`^${selectedProduct.sku}-(\\d+)$`));
        return match ? parseInt(match[1], 10) : 0;
    });




    // Determine the next valid SKU
    const nextSuffix = suffixes.length > 0 ? Math.max(...suffixes) + 1 : 1;
    const sku = `${selectedProduct.sku}-${nextSuffix}`;


    console.log("productData----", productData);

    // Build the product data to create
    return {
        ...selectedProduct,
        options: [],
        pricing_id: productData.pricing_id,
        product_id: -1,
        "2d_image_url": productData["2d_image_url"] || "",
        "3d_image_url": "",
        is_customizable: true,
        name: productData.name,
        sku: sku,
    };
};

export default getNextProductData;
